import Lenis from 'lenis';

const PREVENT_LENIS_INSIDE_ID = ['CybotCookiebotDialog', 'site-header'];
let instance = null;
export default class SmoothScroll {
  constructor() {
    if (instance) {
      return instance;
    }
    instance = this;

    /* Global access */
    window.smoothScroll = this;

    this.lenis = new Lenis({
      autoRaf: true,
      duration: 0.8,
      prevent: (node) => PREVENT_LENIS_INSIDE_ID.includes(node.id),
    });
  }
}
